import { getOrganizationById } from '@dealstack/frontend/shared/dataExchange/services/organization.api';
import { OrganizationRes } from '@dealstack/shared/lib/generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

type QueryKey = readonly [string, string?];

interface Options
	extends Omit<
		UseQueryOptions<OrganizationRes | null, unknown, OrganizationRes | null, QueryKey>,
		'queryKey' | 'queryFn' | 'staleTime' | 'select' | 'enabled'
	> {
	enabled?: boolean;
}

export const useOrganization = (organizationId?: string, options?: Options) => {
	return useQuery({
		queryKey: ['getOrganisationById', organizationId],
		queryFn: () => {
			if (!organizationId) {
				return Promise.resolve(null);
			}

			return getOrganizationById(organizationId);
		},
		...options,
		enabled: !!organizationId && (options?.enabled ?? true),
	});
};
